import { ManagedReceivingGlobalApiV2 as ApiV2 } from "@capstone/mock-api";
import { OrganizationTypeName } from "src/app/core/auth/user.service";
import { getEnumMember } from "src/utils";

export class OrganizationType {
  public constructor(args: ClassProperties<OrganizationType>) {
    this.id = args.id;
    this.name = args.name;
  }

  public readonly id: number;
  public readonly name: OrganizationTypeName;

  public static deserialize(
    apiModel: ApiV2.OrganizationTypeDto,
  ): OrganizationType {
    return new OrganizationType({
      id: apiModel.id,
      name: getEnumMember(OrganizationTypeName, apiModel.name),
    });
  }

  public static deserializeList(
    apiModel: ApiV2.OrganizationTypeDto[],
  ): readonly OrganizationType[] {
    return apiModel.map((model) => OrganizationType.deserialize(model));
  }
}
